import {Component, Input, OnInit} from '@angular/core';
import {
  OrganizationInformationRestService
} from '../../../shared/services/nso-data-portal/rest-services/organization-information-rest.service';
import {Observable, Subject} from 'rxjs';
import {InteractionTableData} from '../../../shared/types/interaction/interaction-table-data';
import {InteractionData} from '../../../shared/types/interaction/interaction-data';
import {InteractionFilter, TimeFilterTypes} from '../../../shared/types/nso-data-portal/interaction-data';
import {debounceTime} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'wsd-interaction-detail',
  templateUrl: './interaction-detail.component.html',
  styleUrls: ['./interaction-detail.component.css'],
  animations: [
    trigger('FadeAnim', [
      state('in', style({opacity: 1})),
      transition(':enter', [
        style({opacity: 0}),
        animate(600)
      ]),
      transition(':leave', [
        animate(600, style({opacity: 0}))
      ])
    ])
  ]
})
export class InteractionDetailComponent implements OnInit {

  @Input()
  organizationId: number;

  detail: InteractionData;

  pageSize: number = 5;
  first: number = 0;

  interactions$: Observable<InteractionTableData>;

  filter: InteractionFilter = {
    lastDays: TimeFilterTypes.ALL
  };

  searchChanged = new Subject<void>();

  constructor(private organizationService: OrganizationInformationRestService) {
  }

  ngOnInit() {
    this.loadData(0);
    this.searchChanged.pipe(
      debounceTime(500)
    ).subscribe(() => this.loadData(0));
  }

  search() {
    this.searchChanged.next();
  }

  loadData(page: number) {
    this.interactions$ =
      this.organizationService.getInteractions(
        this.organizationId,
        this.filter,
        this.pageSize,
        page
      );
  }

  onPageChange(event) {
    this.loadData(event.first / event.rows);
    this.first = event.first;
  }

  cutSummaryText(interactionSummary: String) {
    let longText = false;
    if (interactionSummary.length > 300) {
      longText = true;
    }
    let summary = interactionSummary.substr(0, 300);
    if (longText) {
      summary += '...';
    }
    return summary;
  }
}
